import React, { createContext, useContext, useState, useEffect } from 'react';

// Creating AuthContext
const AuthContext = createContext();

// Providing the AuthContext to the children components
export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  // Simulate fetching user data (you can replace this with real API calls)
  useEffect(() => {
    // Simulating a login check
    const fetchUserData = () => {
      const storedUser = localStorage.getItem('user'); // Assuming user data is stored in localStorage
      if (storedUser) {
        setUser(JSON.parse(storedUser)); // Set user from localStorage or API
      } else {
        setUser(null); // If no user is found, set to null
      }
    };

    fetchUserData();
  }, []);

  const logout = () => {
    setUser(null);
    localStorage.removeItem('user'); // Clear user data
  };

  return (
    <AuthContext.Provider value={{ user, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

// Custom hook to use Auth context
export function useAuth() {
  return useContext(AuthContext);
}
